import { Fnv1a64 } from "@highmarch/domain";
import { RandomSource } from "./ports";

/** Offline seed derivation: FNV-1a over (playerId, level, attempt). Replaced by server seeds in Phase 2. */
export class OfflineSeedProvider implements RandomSource {
  levelSeed(playerId: string, level: number, attempt: number): bigint {
    const h = new Fnv1a64();
    h.writeString(playerId);
    h.writeInt(level);
    h.writeInt(attempt);
    return h.value;
  }
}
